import React, { useEffect, useState } from 'react';
import { Box, Typography, useTheme, Card } from '@mui/material';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const ProjectDashboardPie = ({ projectData }) => {
  console.log("projectData in pie chart", projectData);
  const theme = useTheme();
  const [myData, setMyData] = useState({
    milestone: 0,
    phase: 0,
    sprint: 0
  })

  useEffect(() => {
    const res = {
      data: {
        milestone: parseFloat(projectData?.project_progress?.project_completion_percentage.replace('%', '')) || 0,
        phase: parseFloat(projectData?.project_progress?.milestone_completion_percentage.replace('%', '')) || 0,
        sprint: parseFloat(projectData?.project_progress?.task_completion_percentage.replace('%', '')) || 0,
      }
    }
    setMyData({
      milestone: res.data.milestone,
      phase: res.data.phase,
      sprint: res.data.sprint
    })
  }, [])

  // Progress values
  const milestoneProgress = myData.milestone // Blue
  const phaseProgress = myData.phase;     // Red
  const sprintProgress = myData.sprint;    // Cyan

  // ✅ Helper: ring dataset with grey background
  const createDataset = (progress, color, cutout, radius) => ({
    data: [progress, 100 - progress],
    backgroundColor: [color, theme.palette.grey[300]],
    borderWidth: 0,
    rotation: 120,
    circumference: 360,
    cutout,
    radius,
    borderRadius: 0,
    hoverOffset: 0,
  });

  const data = {
    datasets: [
      createDataset(milestoneProgress, '#4A90E2', '70%', '85%'), // Milestone
      createDataset(phaseProgress, '#FF6F61', '55%', '70%'),     // Phase
      createDataset(sprintProgress, '#00B8D9', '40%', '55%'),    // Sprint
    ],
  };

  const options = {
    cutout: '40%',
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
  };

  return (
    <Card
      sx={{
        width: "97%",
        height: 263,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        bgcolor: theme.palette.background.card,
        borderRadius: 3,
        boxShadow: 3,
        p: 2,
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{
          mb: 2,
          fontWeight: 600,
          // color: theme.palette.text.primary,
          color: "#243465"
        }}
      >
        Project Progress
      </Typography>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center', // ✅ vertically center legends with pie
          justifyContent: 'flex-start',
          pb: 1.5,
          gap: 3, // space between chart and legends
          width: '100%',
        }}
      >
        {/* Pie Chart */}
        <Box sx={{ width: 180, height: 180 }}>
          <Doughnut data={data} options={options} />
        </Box>

        {/* Legends */}
        <Box
          sx={{
            display: 'flex',

            flexDirection: 'column',
            // gap: 2, // spacing between legend items
          }}
        >
          <LegendDot color="#4A90E2" label="Project" theme={theme} />
          <LegendDot color="#FF6F61" label="Milestone" theme={theme} />
          <LegendDot color="#00B8D9" label="Task" theme={theme} />
        </Box>
      </Box>
    </Card>
  );
};

// ✅ Legend Component
const LegendDot = ({ color, label, theme }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    <Box
      sx={{
        width: 10,
        height: 10,
        borderRadius: '50%',
        backgroundColor: color,
      }}
    />
    <Typography
      variant="body2"
      sx={{ color: theme.palette.text.secondary, fontSize: 13 }}
    >
      {label}
    </Typography>
  </Box>
);

export default ProjectDashboardPie;

